/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import cx from 'classnames';
import styles from './styles.module.scss';
import { Text, View } from '@az/starc-ui';
import { useLabels } from '@/hooks/useLabels';

type SecondaryRatingProps = {
  ratingValue: number;
  ratingDisplayLabel: string;
  ratingValueRange: number;
};

const labelMap = {
  outOf5Stars: 'label_reviews_outOf5Stars',
};

export const SecondaryRating = ({
  ratingDisplayLabel,
  ratingValueRange,
  ratingValue,
}: SecondaryRatingProps) => {
  const labels = useLabels(labelMap);
  const steps = new Array(ratingValueRange).fill(0);

  return (
    <>
      <Text variant="small-body">{ratingDisplayLabel}</Text>
      <View className={styles.ratingContainer}>
        <p className="sr-only">{`${ratingValue} ${labels.outOf5Stars}`}</p>
        {steps.map((_, index) => (
          <span
            role="presentation"
            key={`sr-${index}`}
            className={cx(styles.rectangle, { [styles.active]: index < ratingValue })}
          />
        ))}
      </View>
    </>
  );
};
